// Friendly ESM reminder: we can use naked variable syntax because export default is used in module at path ;
// declared naked variable in an import statement via ESM source code is strictly initialized with the function/variable/class published/tagged with “export default” in the module (file) the path in the import statement references (i.e. on the default property on that modules namespaceobject)
// with this syntax you can name the imported variable anything you want when importing the "default export" because the import statement is essentially doing classical (longhand) variable declaration and initialization: const myVar = namespaceObject.default
// not the shorthand object destructuring syntax, which is what causes you to be locked into the name of the eponymous property on the object you are pointing at - but which makes us able to write the declaration and initialization shorthand!

import { HashRouter, Route, Routes } from 'react-router-dom'
import Home                 from '../components/home/Home.js'
import AuthGuard            from '../components/auth/AuthGuard.js'
import Main                 from '../components/dashboards/Main.js'
import PublicComparables    from '../components/dashboards/PublicComparables.js'
import TransactionComps     from '../components/dashboards/TransactionComps.js'
import FootballField        from '../components/dashboards/FootballField.js'
import Leaderboard          from "../components/dashboards/Leaderboard.js"

const App= () => {

    return (
        <>
        <HashRouter>
            <Routes>
                <Route path="/" exact                       element={<Home />}              /> 
                <Route path="/authguard"                    element={<AuthGuard />}          > 
                    <Route path="dashboards"                element={<Main />}               >     
                        <Route path="public-comparables"    element={<PublicComparables />} />
                        <Route path="transaction-comps"     element={<TransactionComps />}  />
                        <Route path="football-field"        element={<FootballField />}     />
                        <Route path="leaderboard"           element={<Leaderboard   />}     />
                    </Route>
                </Route>
            </Routes>
        </HashRouter>
        </>
    )
}

export default App;
